import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  SecurityContext,
  inject,
  signal,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ReleaseDialogData } from './interfaces';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';
import { ReleaseNotesLinkComponent } from '@shared/components/release-notes-link/release-notes-link.component';

@Component({
  imports: [
    CommonModule,
    TranslateModule,
    DvDialogContentComponent,
    DvButtonComponent,
    ReleaseNotesLinkComponent,
  ],
  selector: 'app-release-notes-dialog',
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReleaseNotesDialogComponent
  extends DvDialogContent<ReleaseDialogData, ReleaseNotesDialogComponent>
  implements OnInit
{
  private sanitizer = inject(DomSanitizer);

  sanitizedBody = signal<string | null>(null);

  ngOnInit(): void {
    this.sanitizedBody.set(
      this.sanitizer.sanitize(SecurityContext.HTML, this.data.releaseNotes)
    );
  }

  confirm(): void {
    this.dialogRef.onClose('confirm');
  }
}
